// removed by extract-text-webpack-plugin
module.exports = {"BreadBottom":"BurgerIngredient__BreadBottom__HuxZP","BreadTop":"BurgerIngredient__BreadTop__10-cT","Seeds1":"BurgerIngredient__Seeds1__3xHtz","Seeds2":"BurgerIngredient__Seeds2__1cUso","Patty":"BurgerIngredient__Patty__3Uzb1","Cheese":"BurgerIngredient__Cheese__1FxeY","Salad":"BurgerIngredient__Salad__1iTJE","PaneerTikka":"BurgerIngredient__PaneerTikka__3W77h"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/BurgerIngredient/BurgerIngredient.css
// module id = 75
// module chunks = 16